export const MuiColors = {
  primaryColor: 'var(--primary-color)',
  secondaryColor: 'var(--secondary-color)',
  accentColor: 'var(--accent-color)',
  darkAccentColor: 'var(--dark-accent-color)',
  lightAccentColor: 'var(--light-accent-color)',
  veryLightAccentColor: 'var(--very-light-accent-color)',
  accentHoverColor: 'var(--accent-hover-color)',
  additionalColor: 'var(--additional-color)',
  lightSecondaryColor: 'var(--light-secondary-color)',
  veryLightSecondaryColor: 'var(--very-light-secondary-color)',
  darkSecondaryColor: 'var(--dark-secondary-color)',
  secondaryHoverColor: 'var(--secondary-hover-color)',

  dangerColor: 'var(--danger-color)',
  dangerHoverColor: 'var(--danger-hover-color)',
  successColor: 'var(--success-color)',

  stepActiveBackgroundColor: 'var(--step-active-background-color)',
  stepActiveTextColor: 'var(--step-active-text-color)',
  stepDoneBackgroundColor: 'var(--step-done-background-color)',
  stepDoneTextColor: 'var(--step-done-text-color)',
  stepDisabledBackgroundColor: 'var(--step-disabled-background-color)',
  stepDisabledTextColor: 'var(--step-disabled-text-color)',
};
